import { atomWithReset } from "jotai/utils";

export const automationDetailModalAtom = atomWithReset<{
  visible: boolean;
  automationId: string | null;
}>({ visible: false, automationId: null });
